<script>
import HKLButton from './HKLButton'

/**
 * @type {import('vue').Component}
 */
const HKLSearchButton = {
  name: 'HKLSearchButton',
  extends: HKLButton,
  props: {
    color: {
      type: String,
      default: 'orange',
    },
    action: {
      type: String,
      default: 'search',
    },
  },
}

export default HKLSearchButton
</script>
